var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultInfluentiaUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1895,
    cy: 25.7854,
    r: 25,
    fill: "#CDD9E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9785 20.3198C35.4933 18.4619 31.356 17.6372 24.8452 18.9067C19.0045 20.0418 13.848 22.4974 12.6287 26.6579C10.6229 25.7962 9.18945 24.6379 9.18945 22.5252C9.18945 17.1739 14.9882 14.1438 21.6759 12.8418C33.5573 10.5253 37.5363 15.1909 37.9785 20.3198Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5484 29.1274C31.9695 33.6957 27.3854 34.8077 22.7408 30.8602C20.0835 28.59 15.6855 27.9738 12.6279 26.6626C13.8473 22.502 19.0084 20.0464 24.8444 18.9113C31.3552 17.6418 35.4972 18.4665 37.9777 20.3244C38.2663 23.6696 37.0562 27.2093 35.5484 29.1321V29.1274Z",
    fill: "#CDD9E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7188 35.1922C35.1353 39.7605 30.5512 40.8725 25.9066 36.9204C21.5041 33.1722 12.3545 33.9366 12.3545 28.5853C12.3545 27.9043 12.4476 27.2649 12.6244 26.6579C15.6867 27.9691 20.08 28.59 22.7373 30.8556C27.3819 34.8077 31.966 33.6957 35.5449 29.1228C37.0527 27.2 38.2674 23.6603 37.9742 20.3151C42.9771 24.0402 41.2692 31.9305 38.7142 35.1876L38.7188 35.1922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultInfluentiaUser);
export default __webpack_public_path__ + "static/media/default-influentia-user.44dda90090387dfbdc61bd597b50927e.svg";
export { ForwardRef as ReactComponent };